import request from '../../utils/requests'
/** * Tag: Organization */
const baseUrl ="/api/Organization";

/** * 更新 * @param {*} body * { *    Name Desc:机构名称 Required:false *    Address Desc:机构地址 Required:false *    Province Desc:省编号 Required:false *    City Desc:城市编号 Required:false *    Area Desc:地区编号 Required:false *    Location Desc:地图坐标39.90469,116.40717 Required:false *    LogoUrl Desc:机构logo Required:false *    Principal Desc:负责人 Required:false *    PrincipalPhone Desc:负责人手机号 Required:false *    LandlineTel Desc:固定电话 Required:false *    QRCode Desc:机构二维码 Required:false *    TrainType Desc:培训类型 Required:false *    OrganizationId Desc:后台用 Required:false *    BusinessLicenseImage Desc:营业执照图片路径 Required:false *    BusinessLicenseNo Desc:营业执照号 Required:false *    OrgFullName Desc:机构全名 Required:false *    OrgCode Desc:机构代码/三证合一号 Required:false * } */async function _update(body) {  return request(baseUrl+'/update',{    method: 'POST',    body: body,  });
}

/** * 更新机构介绍 * @param {*} body * { *    Introduce Desc:备注 Required:false *    OrganizationId Desc:主键（后台使用） Required:false * } */async function _updateIntroduce(body) {  return request(baseUrl+'/updateIntroduce',{    method: 'POST',    body: body,  });
}

/** * 获取单个Model */async function _getModel() {  return request(baseUrl+'/getModel',{    method: 'GET',  });
}

/** * 获取机构规模学员列表 * @param {*} body * { *    NameOrPhone Desc:姓名或手机号 Required:false *    OrgId Desc:后端赋值 Required:false *    Start Desc:开始行数 从0开始 Required:false *    Length Desc:页面大小 Required:false *    End Desc:结束行数 Required:false * } */async function _getScaleStudentList(body) {  return request(baseUrl+'/getScaleStudentList',{    method: 'POST',    body: body,  });
}

/** * 获取当前在读和停课学员汇总 */async function _getScaleStudentSum() {  return request(baseUrl+'/getScaleStudentSum',{    method: 'GET',  });
}

/** * 获取当前机构规模 */async function _orgSize() {  return request(baseUrl+'/orgSize',{    method: 'GET',  });
}

/** * 获取手机号码所在机构 * @param {*} param * { *    phone Desc: Required:true * } */async function _orgListByPhone(param) {  return request(baseUrl+'/orgListByPhone',{    method: 'GET',    params: param,  });
}

/** * 重置密码 * @param {*} body * { *    Phone Desc:手机号码 Required:false *    Pwd Desc:密码 Required:false *    OrgId Desc:机构Id Required:false * } */async function _changeAccountPasswd(body) {  return request(baseUrl+'/changeAccountPasswd',{    method: 'POST',    body: body,  });
}

/** * 获取机构H5微商城 */async function _getOrgH5MallInfo() {  return request(baseUrl+'/getOrgH5MallInfo',{    method: 'GET',  });
}

export default{  _update,  _updateIntroduce,  _getModel,  _getScaleStudentList,  _getScaleStudentSum,  _orgSize,  _orgListByPhone,  _changeAccountPasswd,  _getOrgH5MallInfo}



// WEBPACK FOOTER //
// ./src/services/organization.js